import classNames from 'classnames';
import {useI18n} from '../../contexts/I18n.client';
import {Container} from '../Container.client';
import {ProductFeature} from './ProductFeature';
import {
  AnalyzeAnimation,
  CustomizeAnimation,
  SellAnimation,
} from './animations';

type ProductFeaturesProps = {
  className?: string;
};

export const ProductFeatures = (props: ProductFeaturesProps) => {
  const {className} = props;

  const {t} = useI18n();

  return (
    <Container
      className={classNames('flex', 'flex-col', 'gap-36', className)}
      backgroundGradientStart="light-blue"
      backgroundGradientEnd="white"
    >
      <ProductFeature
        title={t('productFeatures.productFeature1.title')}
        body={t('productFeatures.productFeature1.body')}
        image={<SellAnimation />}
        position={1}
      />

      <ProductFeature
        title={t('productFeatures.productFeature2.title')}
        body={t('productFeatures.productFeature2.body')}
        image={<CustomizeAnimation />}
        position={2}
      />

      <ProductFeature
        title={t('productFeatures.productFeature3.title')}
        body={t('productFeatures.productFeature3.body')}
        image={<AnalyzeAnimation />}
        position={3}
      />
    </Container>
  );
};
